import { ChevronDown } from 'lucide-react';

export interface AccordionProps {
  header: React.ReactNode;
  open: boolean;
  onToggle: () => void;
  children?: React.ReactNode;
  className?: string;
}

// Bordered, click-to-expand card with a chevron toggle — shared shape behind DataPrincipals'
// ConsentNoticeCard (one card per consent notice, expanding to its purposes).
export const Accordion = ({ header, open, onToggle, children, className = '' }: AccordionProps) => (
  <div className={`shrink-0 border border-gray-200 rounded-xl overflow-hidden ${open ? 'bg-[#F9F8FF]' : 'bg-white'} ${className}`}>
    <div className="flex items-center justify-between px-5 py-3.5 cursor-pointer" onClick={onToggle}>
      {header}
      <ChevronDown className={`w-4 h-4 text-gray-500 transition-transform shrink-0 ${open ? 'rotate-180' : ''}`} />
    </div>
    {open && <div className="border-t border-gray-100 px-5 py-3">{children}</div>}
  </div>
);
